import { Component, Fragment } from 'react'
import { Section, H1, H3, H4, Body1, Toggle, ArticleList } from '../../../cdl-react-components/components'
import ArticleDisplay from '../../../Utilities/ArticleDisplay'

class LearningLibraryDesktop extends Component {
    render() {
        const { groups, periods, filteredArticles, recentArticles, allGroupsSelected, allPeriodsSelected } = this.props.parentState

        return (
            <div className="learning-library__container">
                <div className="learning-library__content">
                    {filteredArticles && filteredArticles.length > 0 ? (
                        filteredArticles.map((articleGroup, i) => (
                            <Section key={'learning-library__content__section--' + i}>
                                <H3>{articleGroup.groupName}</H3>
                                <div className="learning-library__article__container">
                                    {articleGroup.articles && articleGroup.articles.map((article, j) => (
                                        <ArticleDisplay 
                                            key={`learning-library__content__section__article--${i}-${j}`} 
                                            article={article} />
                                        ))}
                                </div>
                            </Section>
                        ))
                    ) : (<H4 className="learning-library__content__message">No Content Found</H4>)
                    }
                </div>
                <div className="learning-library__search">
                    <div className="learning-library__search__inner">
                        <H1 className="learning-library__search__header">CDL Knowledge Portal</H1>
                        <Toggle 
                            type="checkbox"
                            checked={allGroupsSelected} 
                            onChange={this.props.parentFunc.toggleAllGroups}>Select All</Toggle>
                        <hr style={{ background: '#CCC', margin: '4px 0' }} />
                        {groups && groups.map((group, i) => (
                            <Fragment key={'learning-library__group-checkbox--' + i}>
                                <Toggle 
                                    type="checkbox"
                                    checked={group.active}
                                    onChange={() => this.props.parentFunc.toggleGroup(group.id)}>
                                        {`${group.name} <span class="toggle__highlight">(${group.count})</span>`}
                                </Toggle><br/>
                            </Fragment>
                        ))}
                        <H3>Period</H3>
                        <Toggle 
                            type="checkbox"
                            checked={allPeriodsSelected} 
                            onChange={this.props.parentFunc.toggleAllPeriods}>Select All</Toggle>
                        <hr style={{ background: '#CCC', margin: '4px 0' }} />
                        {periods && periods.map((period, i) => (
                            <Fragment key={'learning-library__period-checkbox--' + i}>
                                <Toggle 
                                    type="checkbox"
                                    checked={period.active}
                                    onChange={() => this.props.parentFunc.togglePeriod(period.id)}>
                                        {period.name}
                                </Toggle><br/>
                            </Fragment>
                        ))}
                        <hr />
                        <Body1>The CDL Knowledge Portal is an exclusive Digest resource to help users acquire a basic understanding of several geo- and completions-centric topics. These articles are pulled directly from CDL’s archives.</Body1>
                        <H3>Recent Articles</H3>
                        <ArticleList 
                            articles={recentArticles}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default LearningLibraryDesktop